<template>
<body class="hold-transition layout-top-nav">
  <div class="wrapper">
    <!-- Navbar -->
    <nav class="main-header navbar navbar-expand-md navbar-light navbar-white">
      <div class="container">
        <a href="/download" class="navbar-brand">
          <span class="brand-text font-weight-light text-warning">FX</span>hanuman
        </a>

        <div class="collapse navbar-collapse order-3" id="navbarCollapse"></div>
      </div>
    </nav>
    <!-- /.navbar -->

    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <div class="content-header">
        <div class="container">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h1 class="m-0 text-dark">
                Product
                <small>EA FXH-RB</small>
              </h1>
            </div>
            <!-- /.col -->
          </div>
          <!-- /.row -->
        </div>
        <!-- /.container-fluid -->
      </div>
      <!-- /.content-header -->

      <!-- Main content -->
      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col-md-6 col-lg-7">
              <div class="card">
                <img
                  class="card-img-top"
                  ng-src="../../../public/img/products/carry-trade.jpg"
                  alt="Card image cap"
                  src="../../../public/img/products/fxh-rb.jpg"
                />
                <div class="card-body">
                  <p class="card-text ng-binding">เป็นระบบ Auto Rebalance สำหรับการทำแครี่เทรด.</p>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-5 p-1">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title ng-binding">FXH-RB</h5>
                  <p class="card-text"></p>
                </div>
                <ul class="list-group list-group-flush text-right">
                  <li class="list-group-item">
                    <h3>
                      Price
                      <span class="text-danger ng-binding">500</span> .-
                    </h3>
                  </li>
                  <li class="list-group-item ng-binding">Update : 06/12/2019</li>
                  <li class="list-group-item">
                    <a href="https://drive.google.com/open?id=1azrLGnfSJqIJXFv_YWR925eMD3ByL3Us" target="_blank" class="btn btn-danger btn-block">Download Now</a>
                  </li>
                </ul>
              </div>
            </div>

            <!-- Card EA Content  -->
            <div class="col-md-12">
              <div class="card">
                <div class="card-header bg-light">
                  <h4>รายละเอียด</h4>
                </div>

                <div class="container">
                  <div class="md-form col-md-12 mt-1">
                    <h1>EA Auto Rebalance</h1>

                    <p>EA Rebalance เป็นระบบโอนเงินระหว่างบัญชีต่างโบรกเกอร์อัตโนมัติ</p>

                    <p>
                     
                      <strong>ตัวอย่างการใช้งาน SwissquoteBank &amp; AutoRebalance EA</strong>
                    </p>

                    <div>
                      <iframe
                        class="embed-responsive-item"
                        src="https://www.youtube.com/embed/7SNmbVswAM0"
                      ></iframe>
                    </div>

                    <p>
                      <br />ราคาบริการของระบบ AutoRebalance
                    </p>

                    <p>ราคาบัญชีล่ะ 500 บาทต่อเดือน หรือใช้ฟรีสำหรับลูกค้าภายใต้ IB FXhanuman</p>

                    <p>
                      <strong>ขั้นตอนการขอใช้งาน</strong>
                    </p>

                    <div>
                      <iframe
                        class="embed-responsive-item"
                        src="https://www.youtube.com/embed/9H36ct9I8k8"
                      ></iframe>
                    </div>

                    <ol>
                      <li>
                        ชำระเงินค่า EA ได้ที่
                        <u>6417047104 ธ.กรุงเทพ ศราวุฒิ พรหมจรรย์</u> และ แจ้งสลิปการโอนเงินไปที่
                        <u>Line ID:@fxhanuman</u>
                      </li>
                      <li>ดูวิธีติดตั้งและใช้งาน AutoRebalance</li>
                    </ol>

                    <div>
                      <iframe
                        class="embed-responsive-item"
                        src="https://www.youtube.com/embed/VK8qCnphsqE"
                      ></iframe>
                    </div>

                    <div>
                      <iframe
                        class="embed-responsive-item"
                        src="https://www.youtube.com/embed/zZT8_guorNw"
                      ></iframe>
                    </div>

                    <div>
                      <iframe
                        class="embed-responsive-item"
                        src="https://www.youtube.com/embed/zTfj8-vtYyM"
                      ></iframe>
                    </div>

                    <p>&nbsp;</p>

                    <p>&nbsp;</p>

                    <p>
                      <strong>ข้อตกลงการใช้บริการ</strong>
                      <br />1. การลงทุนขึ้นอยู่กับการตัดสินใจของลูกค้า ซึ่งไม่ผูกพันกับผลการประเมินของลูกค้า และอาจไม่ได้เป็นไปตามระดับความเสี่ยงของการลงทุนที่ได้รับตามแบบประเมินนี้
                      <br />ทั้งนี้ลูกค้ายอมรับความเสี่ยงที่เกิดจากการลงทุน และยอมรับว่าการดำเนินการลงทุนของลูกค้าอาจไม่เป็นไปตามผลการประเมิน ชึ่งอาจมีผลไม่แน่นอนและสามารถปลี่ยนแปลงไปจากผลการประเมินได้
                      <br />2. บริษัทฯ ผู้บริหารรวม,พนักงานเจ้าหน้าที่ ของบริษัทฯ ไม่มีความรับผิดชอบภาระหรือหน้าที่ต่อความเสียหายใดๆ ที่เกิดขึ้นจากการลงทุนของลูกค้า
                      <br />3. บริษัทฯ ขอสงวนสิทธิในการแก้ไขปรับปรุง หรือเปลี่ยนแปลงระบบที่เกี่ยวข้อง โดยไม่จำเป็นต้องแจ้งให้ทราบล่วงหน้า
                      <br />4. บริษัทฯ จะไม่รับผิดชอบต่อการเปลี่ยนแปลง,ปรับปรุงระบบ,ข้อตกลง ต่างๆของธนาคารรวมถึงโบรกเกอร์ ที่ให้บริการลูกค้า
                      <br />5. บริษัทฯ จะไม่รับผิดชอบสิ่งที่เกิดขึ้น เช่น เกิดความผิดพลาดกับอุปกรณ์ของผู้ใช้บริการ หรือจากเหตุสุดวิสัยอื่นใดที่เกิดจากผู้ให้บริการ และผู้ใช้บริการเอง
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <!-- End Card EA Content  -->
            <!-- /.row -->
          </div>
        </div>
        <!-- /.container-fluid -->
      </div>
      <!-- /.content -->
    </div>
    <!-- /.content-wrapper -->

    <!-- Main Footer -->
    <footer class="main-footer">
      <!-- To the right -->
      <div class="float-right d-none d-sm-inline">Anything you want</div>
      <!-- Default to the left -->
      <strong>
        Copyright &copy;2019
        <a href="/download" class="text-dark">
          <b class="text-warning">FX</b>hanuman
        </a>.
      </strong> All rights reserved.
    </footer>
  </div>
  <!-- ./wrapper -->
</body>
</template>

<script>
export default {
  name: "carrytrade"
};
</script>